import { PromiseAxiosResponse } from '@/worker/commands/config/apiInstance';
import { getCurrentInstance } from 'vue';
import { useInternational } from '../locale';
import { showErrorMsg, showMsg, showSuccessMsg } from '../utils/commonUtils';
import { ExportExcelOption, exportToExcelFromServer } from '../utils/exportExcelUtils';
import { useAbortApi } from '../utils/apiUtils';
import { useMyInfoStore } from '@/config/stores/my-info';

export const useExportExcelFromServer = () => {
  const { timezone } = useMyInfoStore();
  const ctx = getCurrentInstance()!.appContext.config.globalProperties;
  const { t } = useInternational();
  const { abortApi, getSignal } = useAbortApi();

  const exportDefaultParams = {
    timezone,
    isReport: true,
    pageNum: undefined,
    pageSize: undefined,
    responseType: 'blob',
  };

  return async <RequestParams, Response>(
    exportToExcelApiFn: (params: RequestParams) => PromiseAxiosResponse<Response>,
    params: RequestParams,
    option: ExportExcelOption = {},
  ) => {
    const { hide: hideLoadingMsg } = showMsg(ctx, 'loading', {
      durationMs: 1000000,
      msgStr: t('NOTI.DOWNLOAD.LOADING'),
      showClose: true,
      icon: true,
      onClose: () => abortApi(),
    });
    try {
      await exportToExcelFromServer(
        exportToExcelApiFn,
        { ...exportDefaultParams, ...params, signal: getSignal() },
        option,
      );
      showSuccessMsg(ctx, t('NOTI.DOWNLOAD.SUCCESSFUL'));
    } catch (e) {
      const error = e as Error;
      if (error.message === 'canceled') return;
      console.log(error);
      showErrorMsg(ctx, t('NOTI.DOWNLOAD.FAILED'));
    } finally {
      hideLoadingMsg();
    }
  };
};
